import { Descriptions, DescriptionsProps, Space } from 'antd'
import React from 'react'
import { OffboardingDetails, OffboardingRecord } from '@/features/offboarding/offboarding.def.ts'
import { TimeDurationUtils } from '@/features/employee-data/employee-data.def.ts'
import { EmptyData } from '@/common/types/misc.def.ts'

type TerminationInfoProps = {
  offboardingRecord: OffboardingRecord
}

const getDescriptionItems = (data: OffboardingDetails): DescriptionsProps['items'] => [
  {
    key: 'noticePeriodDuration',
    label: 'Notice Period Duration',
    children: TimeDurationUtils.toString(data.noticePeriodDuration) || EmptyData.string,
  },
  {
    key: 'noticePeriodStartDate',
    label: 'Resignation/Notice Date',
    children: data.noticePeriodStartDate || EmptyData.string,
  },
  {
    key: 'lastWorkingDay',
    label: 'Last Working Day',
    children: data.lastWorkingDay || EmptyData.string,
  },
  {
    key: 'terminationDate',
    label: 'Termination Date/Exit Date',
    children: data.terminationDate || EmptyData.string,
  },
  {
    key: 'terminationType',
    label: 'Termination Type',
    children: data.terminationType || EmptyData.string,
  },
  {
    key: 'terminationReason',
    label: 'Termination Reason',
    children: data.terminationReason || EmptyData.string,
  },
  {
    key: 'voluntaryResignationReason',
    label: 'Voluntary Resignation Reason',
    children: data.voluntaryResignationReason || EmptyData.string,
  },
  {
    key: 'terminationRemarks',
    label: 'Termination Remarks',
    children: data.terminationRemarks || EmptyData.string,
    span: 2,
  },
]

const TerminationInfo: React.FC<TerminationInfoProps> = ({ offboardingRecord }) => {
  return (
    <Space className="w-full" direction="vertical">
      <Descriptions
        layout="vertical"
        items={getDescriptionItems(offboardingRecord.details)}
      />
    </Space>
  )
}

export default TerminationInfo
